<template>
    <v-dialog v-model="dialog" max-width="1000" :class="darkTheme">
        <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" text>
                <font-awesome-icon :icon="icons.pie" class="fa-fw fa-lg"></font-awesome-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="text-h5">{{ $t('Home.dashboard.overview.assetDistribution') }}</span>
            </v-card-title>
            <v-card-text>
                <div class="pieChart">
                    <HoldingsPieChart :positions="positions"></HoldingsPieChart>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn fab small dark @click="cancel">
                    <font-awesome-icon :icon="icons.cancel" class="fa-fw fa-lg"></font-awesome-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { faChartPieAlt } from '@fortawesome/pro-solid-svg-icons';
import HoldingsPieChart from './HoldingsPieChart.vue';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
export default {
    props: {
        dark: {
            type: Boolean,
            default: false
        }
    },
	components: { HoldingsPieChart },
    data() {
        return {
            dialog: false,
            icons: {
                pie: faChartPieAlt,
                cancel: faTimes
            }
        }
    },
    computed: {
        darkTheme() {
            return this.dark ? 'dark' : '';
        },
        positions() {
            return this.$store.getters.userMergedPositions;
        }
    },
    methods: {
        cancel() {
            this.dialog = false;
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/breakpoints.scss";
.dark .v-btn.v-btn--icon {
    color: #FFF;
}
.pieChart {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #FFF;
    padding: 20px;
}
@media screen and (max-width: $small) {
    .pieChart {
        padding: 0;
    }
}
</style>